export const panelMeta = {
  productName: 'Videro',
  assistantDefaultName: 'Asistente de Videro',
  collectionPaletteLabel: 'Colección cálida',
} as const;
